import React  from 'react';
import UserComponentProto from './user-proto.jsx';


export default function renderDateInList(id, props) {
    return <UserComponentProto renderMode="list" id={id} {...props} />;
}